(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["membership-section"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCarousel(track) {
    if (track.dataset.tiersInit) return;
    track.dataset.tiersInit = '1';

    var grid  = track.querySelector('.tiers-grid');
    var cards = grid ? Array.prototype.slice.call(grid.querySelectorAll('.tier-card')) : [];
    var dotsWrap = track.parentElement.querySelector('.tiers-dots');
    var dots  = dotsWrap ? Array.prototype.slice.call(dotsWrap.querySelectorAll('span')) : [];
    if (!cards.length || !dots.length) return;

    function nearestIndex() {
      var center = track.scrollLeft + track.clientWidth / 2, best = 0, min = Infinity;
      cards.forEach(function (c, i) {
        var d = Math.abs((c.offsetLeft + c.offsetWidth / 2) - center);
        if (d < min) { min = d; best = i; }
      });
      return best;
    }
    function setActive(i) {
      dots.forEach(function (d, di) { d.classList.toggle('active', di === i); });
    }

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { setActive(nearestIndex()); ticking = false; });
    }, { passive: true });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        var card = cards[i];
        var left = card.offsetLeft - (track.clientWidth - card.offsetWidth) / 2;
        track.scrollTo({ left: left, behavior: 'smooth' });
        setActive(i);
      });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.rev-tiers .tiers-carousel').forEach(initCarousel);
  }

  if (document.readyState !== 'loading') { initAll(document); }
  else { document.addEventListener('DOMContentLoaded', function () { initAll(document); }); }

  // Theme editor: re-init when this section is added or re-rendered
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
